import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '@src/app/services/common.service';

import { GlobalStatusService } from '@src/app/services/global-status.service';
import { WalletStatusService } from '@src/app/services/wallet-status.service';
import { AddressProfile } from '@src/app/shared/types/address.type';
import { filter, Subject, takeUntil } from 'rxjs';
import { TransactionService } from '../../transaction/transaction.service';
import { AddressService } from '../address.service';

@Component({
    selector: 'app-address-detail',
    templateUrl: './address-detail.component.html',
    styleUrls: ['./address-detail.component.less'],
    providers: [TransactionService],
})
export class AddressDetailComponent implements OnInit, OnDestroy {
    address: string;

    fetchingWalletProfile = false;
    walletProfile: AddressProfile;

    destroy$ = new Subject<void>();

    constructor(
        private addressService: AddressService,
        private activatedRoute: ActivatedRoute,
        private followStatusService: GlobalStatusService,
        public commonService: CommonService,
        public walletStatusService: WalletStatusService
    ) {}

    ngOnInit() {
        this.fetchingWalletProfile = true;

        this.address = this.activatedRoute.snapshot.paramMap.get('address');

        this.commonService.setAddressIconMap([this.address]);

        this.addressService
            .getAddressProfile(this.address)
            .then(data => (this.walletProfile = data))
            .catch(err => console.warn(err))
            .finally(() => (this.fetchingWalletProfile = false));

        this.followStatusService.followStatusChange$
            .pipe(
                filter(item => !!item),
                filter(({ address }) => address.toLowerCase() === this.address?.toLowerCase()),
                takeUntil(this.destroy$)
            )
            .subscribe(({ status }) => (this.walletProfile.followers_count += status ? 1 : -1));
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
